import { useTranslation } from 'react-i18next'
import { Box, Stack, Typography } from '@mui/material'

import { getTemplate } from './csv'
import { templateDownloadLinkSx, templateTableSx } from './ImportStyles'

const TemplateTable = ({ withPsk }) => {
  const { t } = useTranslation()
  const { columns, requiredColumnsCount } = getTemplate(withPsk)

  const isRequiredColumn = index => index < requiredColumnsCount

  return (
    <Box component="table" sx={templateTableSx}>
      <thead>
        <tr>
          {columns.map(column => (
            <th key={column}>{column}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        <tr>
          {columns.map((column, index) => (
            <Box component="td" key={column} sx={{ color: isRequiredColumn(index) ? '#292929' : '#A5A9B3' }}>
              {isRequiredColumn(index) ? t('ran.import.template_required') : t('ran.import.template_optional')}
            </Box>
          ))}
        </tr>
      </tbody>
    </Box>
  )
}

const TemplatePreview = ({ withPsk, isSsidMissing }) => {
  const { t } = useTranslation()

  return (
    <Stack sx={{ gap: 1.25, padding: 1.5 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" gap={2}>
        <Typography sx={{ fontSize: 12, fontWeight: 600, color: '#292929' }}>
          {t('ran.import.template_preview_title')}
        </Typography>
        {!isSsidMissing && (
          <Box component="a" href={getTemplate(withPsk).url} download sx={templateDownloadLinkSx}>
            <i className="fa-regular fa-arrow-down-to-line" aria-hidden="true" />
            {t('ran.import.template_download', { defaultValue: 'Télécharger' })}
          </Box>
        )}
      </Stack>
      {isSsidMissing ? (
        <Typography sx={{ fontSize: 11, lineHeight: 1.5, color: '#292929' }}>
          {t('ran.import.template_depends_on_ssid', {
            defaultValue: 'Le modèle dépend du SSID. Sélectionnez un SSID pour afficher les colonnes attendues.'
          })}
        </Typography>
      ) : (
        <TemplateTable withPsk={withPsk} />
      )}
      <Typography sx={{ fontSize: 11, lineHeight: 1.5, color: '#7A8096' }}>
        {t('ran.import.template_separator')}
      </Typography>
    </Stack>
  )
}

export default TemplatePreview
